import { SidebarDivider } from '@backstage/core-components';
import Stack from '@mui/material/Stack';
import {
  NotificationIcon,
  SettingsButton,
} from '@internal/backstage-plugin-hm-react';
import { SidebarToggle } from './sidebar-toggle';
import styles from './sidebar.module.css';

export const SidebarControls = () => {
  return (
    <>
      <SidebarDivider className={styles.divider} />
      <Stack
        width="100%"
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        mb={1}
        style={{ height: '36px', margin: '2px 0 6px 0', padding: '0 22px' }}
      >
        <SidebarToggle />
        <NotificationIcon withLink />
        <SettingsButton />
      </Stack>
    </>
  );
};
